import React, {useState} from "react";
import { useRecoilState } from "recoil";
import { trendZoomState } from "../../../../plugins/recoil";

function HeartRateDraw({ data, width,height, style}) {
    const [trendZoom] = useRecoilState(trendZoomState)

    return (        
        <div style={{ width: `${width}px`, height: `${height}px` }} className="flex flex-wrap">
            <div className={`flex justify-evenly items-end relative w-full ${style}`} style={{fontFamily: 'Roboto'}}>                
                {                        
                    data.map((hrData,_) => (
                        <div key={_} className="relative flex flex-col flex-wrap items-center justify-end h-full">
                            <p className="text-[20px] font-normal mb-[5px] text-[#fff]">{hrData.value ? hrData.value : 0}</p>                            
                        </div>
                    ))
                }
            </div>
        </div>
    );
}

export default HeartRateDraw;
